import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/profile/cs_close_n.png'


const _hoisted_1 = { class: "deposit-popup" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = { class: "popup-content" }
const _hoisted_4 = { class: "iframe-container" }
const _hoisted_5 = ["src"]

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'QRPopup',
  setup(__props, { expose: __expose }) {

const { t } = useI18n()
const show = ref(false)
const iframeUrl = ref('')

const open = (url: string) => {
  iframeUrl.value = url
  show.value = true
}

const close = () => {
  show.value = false
}

__expose({
  open,
  close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "center",
    style: { background: 'transparent' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_row, { style: {"display":"flex","align-items":"center"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "22" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.deposite')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "",
                    width: "20",
                    onClick: close
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("iframe", {
              src: iframeUrl.value,
              frameborder: "0"
            }, null, 8, _hoisted_5)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})